import React from 'react';
import { ORDER_STATUS_LABELS, type OrderStatus } from '@/types/order';
import styles from './OrderStatusBadge.module.scss';

const OrderStatusBadge: React.FC<{ status: OrderStatus; className?: string }> = ({ status, className }) => (
  <span className={`${styles.badge} ${className ?? ''}`} data-status={status}>
    {ORDER_STATUS_LABELS[status] ?? status}
  </span>
);

export default OrderStatusBadge;
